module.exports = __webpack_public_path__ + "img/logo-title.a6cb5ee5.png";